import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import BaseModal from '../BaseModal';
import ModifyAutoRenewForm from './ModifyAutoRenewForm';
import { toggleAutoRenew } from 'actions/simoSubs';
import Spinner from 'components/Spinner';

import styles from './styles.module.scss';

class ModifySimoAutoRenew extends Component {
  state = {
    loading: false,
  };

  handleModifyAutoRenew = (values) => {
    const { sub, closeModal, toggleAutoRenew } = this.props;

    if (sub.renewal_enabled === values.renewal_enabled) {
      return;
    }

    this.setState({ loading: true });
    return toggleAutoRenew(sub.id)
      .then(() => {
        closeModal();
        toast.success(
          `Auto Renew ${values.renewal_enabled ? 'Enabled' : 'Disabled'}`,
        );
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { sub, closeModal, isOpen } = this.props;
    const { loading } = this.state;

    const initialValues = {
      renewal_enabled: Boolean(sub && sub.renewal_enabled),
    };

    return (
      <BaseModal
        isOpen={isOpen}
        title="Modify Auto Renew"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <ModifyAutoRenewForm
          initialValues={initialValues}
          onSubmit={this.handleModifyAutoRenew}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  toggleAutoRenew,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModifySimoAutoRenew);
